import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { getPropsBlocker, makePropList } from '../../utils';
import { transitionDurationInSec } from '../../constants';
import { token } from '../../system/mixins';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = makePropList(['isExpanded']);

var accordionStyle = function accordionStyle(_ref) {
  var Accordion = _ref.theme.componentOverrides.Accordion;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        transition: all ", "s ease;\n        ", "\n    "])), transitionDurationInSec, Accordion.Accordion.base);
};

export var AccordionRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    border-top-style: solid;\n    border-top-width: 1px;\n    display: flex;\n    flex-direction: column;\n    margin-top: -1px;\n\n    color: ", ";\n    background-color: ", ";\n\n    ", "\n    ", ";\n    ", "\n"])), token('body.color'), token('body.backgroundColor'), accordionStyle, getComponentOverride('Accordion'), marginAttributes);